module.exports = __webpack_public_path__ + "static/engagement-e0e98dba27e306957c192c5d3ea110ba.jpg";